import axiosInstance from '@/plugins/axios';

// Tela Cessão (S-2231) — porte do CollaboratorController (BFF).
const ServiceCessao = {
  dashboard: (body) => axiosInstance.post('collaborator/dashboard/cessions', body ?? {}),
  count: (body) => axiosInstance.post('collaborator/dashboard/cessions/count', body ?? {}),
  /**
   * @param {*} body
   * @param {{ page?: number, size?: number, sort?: string }} [opts]
   **/
  history: (body, { page = 0, size = 50, sort } = {}) =>
    axiosInstance.post('collaborator/history/cessions', body ?? {}, {
      params: { page, size, ...(sort ? { sort } : {}) },
    }),
  filters: (rootCnpjList) =>
    axiosInstance.post('collaborator/dashboard/filters', rootCnpjList ?? null),
  // Export: enfileira um export persistido (report_process) — não retorna mais binário.
  exportData: (body) => axiosInstance.post('collaborator/history/cessions/export', body ?? {}),
};

export default ServiceCessao;
